import React from 'react';
import { Helmet } from 'react-helmet-async';

function PrivacyPolicy() {
	return (
		<section className="section">
			<div className="container">
				<Helmet>
					<title>Privacy Policy • Appex Connect Hub</title>
				</Helmet>
				<h2>Privacy Policy</h2>
				<p className="helper">
					APEX SPECIALTY CONTRACTING LLC (dba Appex Connect Hub) respects your privacy. We collect the
					information you provide (such as name, email, phone, service interest, and message) to connect
					you with third-party financial service providers and for our own marketing communications when
					you consent. We do not sell personal information.
				</p>
				<ul className="helper">
					<li>We may share your information with selected providers to fulfill your request.</li>
					<li>Message frequency varies. Msg & data rates may apply. Reply STOP to opt out.</li>
					<li>We store consent details (timestamp, method, user agent) for compliance.</li>
					<li>California residents may have additional rights; contact us for requests.</li>
					<li><strong>We do not sell, rent, or share mobile phone numbers with third parties for marketing purposes.</strong></li>
				</ul>
				<p className="helper">
					Contact: 183 Highland Rd, Tarpon Springs, FL 34689
				</p>
			</div>
		</section>
	);
}

export default PrivacyPolicy;


